import { useMemo } from 'react';
import { MANUAL_LANGUAGE_SELECTION } from '@rsos/capstone/src/constants/capabilities';
import { useFlag } from '@rsos/flags';
import useHasCapability from '@rsos/hooks/useHasCapability';

const useHasAccessToManualLanguageSelection = (): boolean => {
  const manualLanguageFeatureFlag = useFlag('manual_language_selection');
  const hasManualLanguageSelectionCapability = useHasCapability(
    MANUAL_LANGUAGE_SELECTION,
  );

  const hasAccessToManualLanguageSelectionFeature = useMemo<boolean>(() => {
    return (
      manualLanguageFeatureFlag &&
      !!hasManualLanguageSelectionCapability?.hasCapability
    );
  }, [manualLanguageFeatureFlag, hasManualLanguageSelectionCapability]);
  return hasAccessToManualLanguageSelectionFeature;
};

export default useHasAccessToManualLanguageSelection;
